export default (state = [], action) => {
  switch (action.type) {
    case 'REQUEST_PAYMENT_METHODS_CONFIGURATION':
      return {
        ...state,
        failureFetching: false,
        isFetching: true,
      };
    case 'RECEIVE_PAYMENT_METHODS_CONFIGURATION':
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        paymentMethods: action.receivedData,
      };
    case 'FAILURE_PAYMENT_METHODS_CONFIGURATION':
      return {
        ...state,
        failureFetching: true,
        isFetching: false,
      };
    default:
      return state;
  }
};
